/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Lấy tất cả các Thuộc tính trong setting object và format lại với new_key là các Thuộc tính đã lấy được
 * @param settings array object setting
 * @returns mapFields template string
 */
export default (settings: Array<object>): object => {
  const mapFields = {} as object;
  for (let i = 0; i < settings.length; i++) {
    const field = settings[i];

    //nomarl field
    if (Object(field).type != 'group') {
      const fieldItem = field;
      Object(mapFields)[Object(fieldItem).name] = fieldItem;
    }

    //group
    if (Object(field).type == 'group' && Object(field).items && Object(field).items.length > 0) {
      for (let h = 0; h < Object(field).items.length; h++) {
        const fieldItem = Object(field).items[h];
        Object(mapFields)[fieldItem.name] = fieldItem;
      }
    }

    //advanced
    if (Object(field).advanced != undefined && Object(field).advanced && Object(field).advanced.length > 0) {
      for (let h = 0; h < Object(field).advanced.length; h++) {
        const fieldItem = Object(field).advanced[h];
        Object(mapFields)[fieldItem.name] = fieldItem;
      }
    }
  }
  return mapFields;
};
